import React from 'react';
import { FixedSizeList as List } from 'react-window';

const Option = ({isSelected, innerProps, label, data, onRemove }) => {
    return (
        <div
            {...innerProps}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '40px',
                padding: '8px',
                borderBottom: '1px solid #ccc',
                color: '$black-text',
                fontFamily: 'OpenSansHebrew-Regular',
                textAlign: 'right',
                direction: 'rtl'
            }}
        >
            {label}

            {isSelected && <button
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    onRemove(data);
                }}
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: 'black',
                    marginLeft: '10px'
                }}
            >
                X
            </button>}
        </div>
    );
};

const MenuList = ({children, innerProps, options, selectProps }) => {
    const { inputValue, value, onChange } = selectProps;

    const isHebrew = (str) => {
        return /[\u0590-\u05FF]/.test(str);
    };

    //for searchable option
    const filteredOptions = options.filter(option => {
        if (option && option.label) {
            if (isHebrew(inputValue)) {
                return !inputValue || option.label.includes(inputValue);
            } else {
                const lowerCaseInput = inputValue.toLowerCase();
                return !inputValue || (option.label.toLowerCase().includes(lowerCaseInput));
            }
        }
        return false;
    });

    // Reorder filteredOptions so that selected options come first
    const sortedOptions = [
        ...filteredOptions.filter(option => {
            if (Array.isArray(value)) {
                return value.some(obj => obj.label === option.label);
            } else {
                return value && (value.label === option.label);
            }
        }),
        ...filteredOptions.filter(option => {
            if (Array.isArray(value)) {
                return !value.some(obj => obj.label === option.label);
            } else {
                return !value || (value.label !== option.label);
            }
        })
    ];

    const itemCount = sortedOptions.length;
    const itemSize = 40;

    const listHeight = Math.min(itemCount * itemSize, 300);

    return (
        <List
            height={listHeight}
            itemCount={itemCount}
            itemSize={itemSize}
            width="100%"
            innerElementType="div"
        >
            {({ index, style }) => {
                const option = sortedOptions[index];
                let isSelected;

                // Check if value is an array (for multi labels)
                if (Array.isArray(value)) {
                    // If value is an array, check if any object in the array has the same label as the current option
                    isSelected = value.some(obj => obj.label === option.label);
                } else {
                    // If value is not an array, check if value exists and its label matches the current option's label
                    isSelected = value && (value.label === option.label);
                }

                const isDisabled = isSelected;

                return (
                    <div
                        style={{
                            ...style,
                            backgroundColor: isSelected ? '#8533eb' : 'transparent',
                            fontFamily: 'OpenSansHebrew-Regular',
                            fontWeight: isSelected ? 'bold' : 'normal',
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            opacity: isDisabled ? 0.5 : 1,
                        }}
                        onClick={(e) => {
                            if (!isDisabled) {
                                const updatedValue = Array.isArray(value) ? [...value, option] : option;
                                onChange(updatedValue);
                            } else {
                                // Unselect the option if already selected
                                const updatedValue = Array.isArray(value)
                                    ? value.filter(obj => obj.label !== option.label)
                                    : null;
                                onChange(updatedValue);
                            }
                        }}
                    >
                        <Option
                            innerProps={innerProps}
                            value={option.value}
                            label={option.label}
                            isSelected={isSelected}
                            data={option}
                            onRemove={(removedOption) => {
                                const updatedValue = Array.isArray(value)
                                    ? value.filter(obj => obj.label !== removedOption.label)
                                    : null;
                                onChange(updatedValue);
                            }}
                        />
                    </div>
                );
            }}
        </List>
    );
};

export default MenuList;
